export default __webpack_public_path__ + "static/media/Bodoni72C.a0feb2febd1cb64fa5b0c32a5fe5ea4c.woff";